import { baseApi } from "@store/apis";
import localStorageSecureWrapper from "@utilities/localStorageSecureWrapper";

import type { UpdateRequest } from "./models";


const UpdateIsClaimed = baseApi.injectEndpoints({

  endpoints: (builder) => ({
    UpdateIsClaimed: builder.mutation({
      // invalidatesTags: ["Challenges"],
      query: ({ challengeId }: UpdateRequest) => ({
        url: "",
        params: {
          Endpoint: "UpdateIsClaimed",
          ChallengeId: challengeId,
          UserId: localStorageSecureWrapper.getItem("userId")
        },
        method: "GET",
      }),
      transformResponse: (response: { result: boolean }) => response.result,
    }),
  }),
});
export const { useUpdateIsClaimedMutation } = UpdateIsClaimed;

